export default {
  state:{
    resultPdfList:[],
    resultHtmlList:[],
  },
  mutations:{
    setResultPdfList(state,List){
      state.resultPdfList=List
      return  state.resultPdfList
    },
    setResultHtmlList(state,List){
      state.resultHtmlList=List
      return  state.resultHtmlList
    },
  },
  getters:{
    getResultHtmlList(state){
      return state.resultHtmlList;
    },
  },
}
